import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c7e9992"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "table-pagination__list" }
const _hoisted_3 = ["disabled", "aria-label", "title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 5v14m12-14l-7 7 7 7"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled", "aria-label", "title"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "pagination-ellipsis",
  "aria-hidden": "true"
}
const _hoisted_10 = ["disabled", "aria-current", "aria-label", "onClick"]
const _hoisted_11 = {
  key: 1,
  class: "pagination-ellipsis",
  "aria-hidden": "true"
}
const _hoisted_12 = ["disabled", "aria-label", "title"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["disabled", "aria-label", "title"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M18 5v14M6 5l7 7-7 7"
  })
], -1))
const _hoisted_17 = [
  _hoisted_16
]

import {
  computed,
  nextTick,
  onBeforeUnmount,
  ref,
  watch,
} from "vue";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
    current: null,
    totalPages: null,
    startPage: null,
    endPage: null,
    scrollOnPageChange: null,
    loading: null
  },
  emits: ["page-changed"],
  setup(__props: any, { emit }: { emit: ({
  (e: "page-changed", page: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  current: number;
  totalPages: number;
  startPage: number;
  endPage: number;
  scrollOnPageChange?: boolean;
  loading?: boolean;
}





const paginationRoot = ref<HTMLElement | null>(null);
const isNavigating = ref(false);
let navigationTimeout: number | null = null;

const hasFirst = computed(() => props.startPage > 1);
const hasLast = computed(() => props.endPage < props.totalPages);
const hasPrev = computed(() => props.current > 1);
const hasNext = computed(() => props.current < props.totalPages);
const nextPage = computed(() => props.current + 1);
const prevPage = computed(() => props.current - 1);

const pages = computed(() => {
  const result: number[] = [];
  for (let page = props.startPage; page <= props.endPage; page += 1) {
    result.push(page);
  }
  return result;
});

const clearNavigationState = () => {
  isNavigating.value = false;
  if (navigationTimeout !== null) {
    window.clearTimeout(navigationTimeout);
    navigationTimeout = null;
  }
};

const changePage = (page: number) => {
  if (
    isNavigating.value ||
    page === props.current ||
    page < 1 ||
    page > props.totalPages
  ) {
    return;
  }

  isNavigating.value = true;
  emit("page-changed", page);
  navigationTimeout = window.setTimeout(clearNavigationState, 10000);
};

const findScrollAnchor = (): HTMLElement | null => {
  const root = paginationRoot.value;
  if (!root) {
    return null;
  }

  const viewport = window.matchMedia("(max-width: 640px)").matches
    ? "mobile"
    : "desktop";
  const anchors = Array.from(
    document.querySelectorAll<HTMLElement>("[data-pagination-scroll-anchor]")
  );
  let nearest: HTMLElement | null = null;

  anchors.forEach((anchor) => {
    if (!anchor.isConnected || anchor.getClientRects().length === 0) {
      return;
    }

    const anchorViewport = anchor.dataset.paginationScrollAnchor;
    if (anchorViewport && anchorViewport !== viewport) {
      return;
    }

    const position = anchor.compareDocumentPosition(root);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
      nearest = anchor;
    }
  });

  return nearest;
};

watch(
  () => props.current,
  async (current, previous) => {
    if (current === previous) {
      return;
    }

    clearNavigationState();
    if (props.scrollOnPageChange === false) return;
    await nextTick();
    findScrollAnchor()?.scrollIntoView({ behavior: "auto", block: "start" });
  }
);
watch(
  () => props.loading,
  (loading, previous) => {
    if (previous && !loading) clearNavigationState();
  }
);

onBeforeUnmount(clearNavigationState);

return (_ctx: any,_cache: any) => {
  return (__props.totalPages > 1)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: (_value, _refs) => {
          _refs['paginationRoot'] = _value
          paginationRoot.value = _value
        },
        class: "table-pagination"
      }, [
        _createElementVNode("nav", {
          class: "table-pagination__card card-global mb-3 text-gray-700",
          "aria-label": _unref(t)('pagination.navigation')
        }, [
          _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "pagination-button",
                disabled: !_unref(hasPrev) || isNavigating.value,
                "aria-label": _unref(t)('pagination.firstPage'),
                title: _unref(t)('pagination.firstPage'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage(1)))
              }, _hoisted_5, 8, _hoisted_3)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "pagination-button",
                disabled: !_unref(hasPrev) || isNavigating.value,
                "aria-label": _unref(t)('pagination.previousPage'),
                title: _unref(t)('pagination.previousPage'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (changePage(_unref(prevPage))))
              }, _hoisted_8, 8, _hoisted_6)
            ]),
            (_unref(hasFirst))
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, " … "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pages), (page) => {
              return (_openBlock(), _createElementBlock("li", { key: page }, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["pagination-button pagination-page", { 'btn-page-current': __props.current === page }]),
                  disabled: __props.current === page || isNavigating.value,
                  "aria-current": __props.current === page ? 'page' : undefined,
                  "aria-label": `${_unref(t)('pagination.page')} ${page}`,
                  onClick: ($event: any) => (changePage(page))
                }, _toDisplayString(page), 11, _hoisted_10)
              ]))
            }), 128)),
            (_unref(hasLast))
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, "…"))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "pagination-button",
                disabled: !_unref(hasNext) || isNavigating.value,
                "aria-label": _unref(t)('pagination.nextPage'),
                title: _unref(t)('pagination.nextPage'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage(_unref(nextPage))))
              }, _hoisted_14, 8, _hoisted_12)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "pagination-button",
                disabled: !_unref(hasNext) || isNavigating.value,
                "aria-label": _unref(t)('pagination.lastPage'),
                title: _unref(t)('pagination.lastPage'),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (changePage(__props.totalPages)))
              }, _hoisted_17, 8, _hoisted_15)
            ])
          ])
        ], 8, _hoisted_1)
      ], 512))
    : _createCommentVNode("", true)
}
}

})